import script from "./DialogBase.vue?vue&type=script&lang=ts"
export * from "./DialogBase.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__